import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const items = [{
  icon: '📖',
  name: 'Libro "Merezco la Vida de Mis Sueños"',
  value: '$37 USD'
}, {
  icon: '📓',
  name: 'Regalo #1: Mi Diario de Manifestación',
  value: '$17 USD'
}, {
  icon: '🎵',
  name: 'Regalo #2: Los Secretos de los Sonidos Mágicos',
  value: '$19 USD'
}, {
  icon: '🔢',
  name: 'Regalo #3: Números Mágicos para una Vida Abundante',
  value: '$27 USD'
}, {
  icon: '💎',
  name: 'Regalo #4: El Poder de los Cristales',
  value: '$27 USD'
}, {
  icon: '🌑',
  name: 'Regalo #5: El Poder de los Eclipses',
  value: '$20 USD'
}, {
  icon: '🌕',
  name: 'Regalo #6: Rituales Lunares',
  value: '$20 USD'
}];
export function ValueStack() {
  return <section className="py-24 px-4 bg-brand-plum text-white relative overflow-hidden" data-id="element-299">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-300">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-301">
          <span className="text-5xl mb-4 block" data-id="element-302">💎</span>
          <h2 className="text-4xl md:text-5xl font-bold text-brand-bg" data-id="element-303">
            Todo Lo Que Recibes Hoy
          </h2>
        </motion.div>

        <div className="bg-white/10 backdrop-blur-md rounded-3xl border border-white/20 overflow-hidden mb-12" data-id="element-304">
          <div className="grid grid-cols-4 bg-white/20 p-4 md:p-6 font-bold text-lg md:text-xl" data-id="element-305">
            <div className="col-span-3" data-id="element-306">📦 Material</div>
            <div className="col-span-1 text-right" data-id="element-307">💰 Valor Real</div>
          </div>

          <div className="divide-y divide-white/10" data-id="element-308">
            {items.map((item, i) => <div key={i} className="grid grid-cols-4 p-4 md:p-6 items-center hover:bg-white/5 transition-colors" data-id="element-309">
                <div className="col-span-3 flex items-center gap-3 text-lg md:text-xl" data-id="element-310">
                  <span className="text-2xl" data-id="element-311">{item.icon}</span>
                  <span className="font-medium" data-id="element-312">{item.name}</span>
                </div>
                <div className="col-span-1 text-right text-brand-gold font-bold text-lg md:text-xl" data-id="element-313">
                  {item.value}
                </div>
              </div>)}
          </div>

          <div className="bg-brand-bg/5 p-6 md:p-8 border-t-2 border-white/20 space-y-4" data-id="element-314">
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2" data-id="element-315">
              <span className="text-lg md:text-2xl font-bold text-white/70" data-id="element-316">
                💰 VALOR TOTAL REAL
              </span>
              <span className="text-2xl md:text-3xl font-bold text-white/70 line-through decoration-brand-rose decoration-4" data-id="element-317">
                $167 USD
              </span>
            </div>
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 bg-brand-rose/20 p-5 rounded-xl border border-brand-rose/50" data-id="element-318">
              <span className="text-xl md:text-3xl font-bold text-brand-gold" data-id="element-319">
                🔥 TU PRECIO HOY
              </span>
              <span className="text-4xl md:text-5xl font-black text-brand-gold whitespace-nowrap" data-id="element-320">
                $14 USD
              </span>
            </div>
          </div>
        </div>

        <div className="text-center mb-12" data-id="element-321">
          <h3 className="text-3xl md:text-4xl font-bold text-brand-gold mb-4" data-id="element-322">
            🔥 TODO ESTO POR SOLO $14 USD
          </h3>
          <p className="text-xl text-white/80 font-serif italic" data-id="element-323">
            (Estás recibiendo $153 USD en valor — hoy, con un solo pago)
          </p>
        </div>

        <CTAButton text="¡QUIERO EL PACK COMPLETO AHORA!" data-id="element-324" />

        <div className="mt-6 text-center text-white/70 font-medium flex flex-col items-center gap-2" data-id="element-325">
          <p data-id="element-326">
            Pago único y seguro a través de Hotmart • Acceso inmediato en tu
            correo
          </p>
          <p className="flex items-center gap-2 justify-center" data-id="element-327">
            <span className="text-brand-gold" data-id="element-328">🔒</span> 100% Seguro • Sin
            suscripciones • Garantía de 7 días incluida
          </p>
        </div>
      </div>

      <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22 opacity=%220.05%22/%3E%3C/svg%3E')] opacity-20 mix-blend-overlay pointer-events-none" data-id="element-329"></div>
    </section>;
}